import './App.css';
import { Switch, Route} from "react-router-dom";
import Top from "./Top";
import Inquiry from "./Inquiry";

const routes = (
  <div>
    <Switch>
      <Route exact path="/" component={Top} />
      <Route path="/inquiry" component={Inquiry} />
    </Switch>
  </div>
)
export default routes;
